interface IUserData {
  name: string;
}

interface IUserInfo {
  startAnalys: IUserData;
  analysGroupingMode: IUserData;
  recentAnalyser: IUserData;
  useCurrentDateAsStartDate: IUserData;
  ekonomiskAnalysDetailTableRowsPerPage: IUserData;
  ekonomiskAnalysUtanSummeringRowsPerPage: IUserData;
  ekonomiskAnalysUpdateStartanalysAtLogin: IUserData;
  ekonomiskAnalysPreferHelarsJamforelse: IUserData;
  ekonomiskAnalysUseZeroSums: IUserData;
  ekonomiskAnalysIsSideMenuPinned: IUserData;
}

export const AnvandarInfo: IUserInfo = {
  startAnalys: {
    name: 'startAnalys',
  },
  analysGroupingMode: {
    name: 'analysGroupingMode',
  },
  recentAnalyser: {
    name: 'recentAnalyser',
  },
  useCurrentDateAsStartDate: {
    name: 'useCurrentDateAsStartDate',
  },
  ekonomiskAnalysDetailTableRowsPerPage: {
    name: 'ekonomiskAnalysDetailTableRowsPerPage',
  },
  ekonomiskAnalysUtanSummeringRowsPerPage: {
    name: 'ekonomiskAnalysUtanSummeringRowsPerPage',
  },
  ekonomiskAnalysUpdateStartanalysAtLogin: {
    name: 'ekonomiskAnalysUpdateStartanalysAtLogin',
  },
  ekonomiskAnalysPreferHelarsJamforelse: {
    name: 'ekonomiskAnalysPreferHelarsJamforelse',
  },
  ekonomiskAnalysUseZeroSums: {
    name: 'useZeroSums',
  },
  ekonomiskAnalysIsSideMenuPinned: {
    name: 'isSideMenuPinned',
  },
};
